import * as React from 'react';
import { NAVIGATION_TARGETS, CtaSectionType } from './enums';

export interface NavigationPayload {
  url: string;
  target: NAVIGATION_TARGETS;
}

export interface Selection {
  eventID: string;
  eventLabel: string;
  marketID: string;
  marketLabel: string;
  selectionID: string;
  selectionLabel: string;
}

export interface Link {
  url?: string;
  target?: string;
}

export interface CTALinks {
  desktop?: Link;
  mobile?: Link;
  nativeIOS?: Link;
  nativeAndroid?: Link;
}

export interface CTAEvent {
  eventPath?: string;
  ctaLinkStandalone?: Link;
}

export interface ImageSrc {
  high?: string;
  medium?: string;
  low?: string;
}

export interface Video {
  youtube?: string;
  vimeo?: string;
}

export interface TermsCondition {
  url?: string;
  label?: string;
}

export interface CTASection {
  type: CtaSectionType;
  CTATextColor?: string;
  CTABackgroundColor?: string;
  CTAText?: string;
  CTALinks?: CTALinks;
  CTAEvent?: CTAEvent;
  selections?: Selection[];
  betslipButtonLabel?: string;
}

export enum PlaceholderSource {
  RQ = 'RQ',
  FV = 'FV',
}

export interface Placeholder {
  name: string;
  source: PlaceholderSource;
  selector: string;
  default?: string;
}

export interface Campaign {
  campaign: string;
  version: string;
  lastUpdate: string;
  ctaSection: CTASection;
  imageSrc?: ImageSrc;
  video?: Video;
  termsCondition?: TermsCondition;
  title?: string;
  bodyText?: string;
  selections?: Selection[];
  logo?: string;
  dismissable?: boolean;
  dismissBtnLabel?: string;
  informSDP?: boolean;
  placeholders?: Placeholder[];
}

export interface CTAArguments {
  ctaSection: CTASection;
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
}

export interface WMUIConstructorArguments {
  campaign: Campaign;
  onDisplayed: () => void;
  onDismissed: (label: string) => void;
  onAccepted: (ctaData: CtaData) => void | Promise<void>;
  onInteraction: (elementId: string) => void;
  congratulationScreenData: CongratulationScreenData;
}

export interface CtaData extends Link, CTAEvent {
  type: string;
}

export interface CongratulationScreenData {
  title: string;
  subTitle: string;
  infoText: string;
  dismissText: string;
}

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export type OpeningAndClosingTags = [string, string];
// tslint:disable-next-line:no-any
export type EscapeFunction = (value: any) => string;
export interface RenderOptions {
  escape: EscapeFunction;
  tags: OpeningAndClosingTags;
}
